import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import FormDropdown from "../form/FormDropdown";

const PrecisionSelector = props => (
  <div className={`PrecisionSelector`}>
    <FormDropdown
      value={props.value}
      options={props.options}
      onChange={props.onChange}
      disabled={props.disabled}
    />
  </div>
);

PrecisionSelector.propTypes = {
  options: PropTypeShapes.listOptionArray.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool
};

export default PrecisionSelector;
